export class BOHealthTechnologyMedicamentDoseDelivered{
    id:number;
    quantity:number;
    measurementMedicationUnits:string;
}